import React, { createContext, useReducer } from "react";

/**
 * 建立 Context
 */
export const RpmContext = createContext({
	state: { rpms: [] },
	dispatch: () => {
		console.warn("未初始化 RpmContext Provider");
	},
});

/**
 * 初始狀態
 */
const initialState = {
	rpms: [], // 存放Rpm資料
};

/**
 * Reducer 處理邏輯
 */
function rpmReducer(state, action) {
	switch (action.type) {
		case "INITIAL_RPMS":
			return {
				...state,
				rpms: action.payload,
			};

		case "UPDATE_RPMS":
			// console.log('更新Rpm資料:', action.payload);
			return {
				...state,
				rpms: action.payload,
			};

		default:
			return state;
	}
}

/**
 * Provider 負責提供 rpm 資料
 */
export const RpmProvider = ({ children }) => {
	const [state, dispatch] = useReducer(rpmReducer, initialState);

	return (
		<RpmContext.Provider value={{ state, dispatch }}>
			{children}
		</RpmContext.Provider>
	);
};

export default RpmProvider;
